import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ClientLoaderService } from './client-loader.service';
import { getI18nBasePath } from './client-path.util';

export class CustomClientTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private clientService: ClientLoaderService
  ) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    return from(this.clientService.getClientName()).pipe(
      switchMap(clientName => {
        const basePath = `${getI18nBasePath()}/${clientName}/${lang}.json`;
        return this.http.get<Record<string, unknown>>(basePath);
      })
    );
  }
}
